import React, { useEffect, useState } from 'react';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import httpHelper from 'utils/http-helper';
import URL_CONSTANTS from 'constants/url-constants';
import { Method_TYPE } from 'utils/http-helper';

const SectortModal = ({ isModalOpen, setIsModalOpen, selectedPoint, getSectorValue, sectorOptions }) => {
    console.log("value123", { sectorOptions, selectedPoint })
    const [formData, setFormData] = useState({
        name: '',
    });

    const [editId, setEditId] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    // Populate data in edit mode
    useEffect(() => {
        if (selectedPoint?.length > 0 && sectorOptions?.length > 0) {
            const selectedSector = sectorOptions.find(
                (sec) => sec.value === selectedPoint[0]?.value
            );

            console.log("selectedSector",selectedSector)
            setFormData({
                name: selectedSector?.label || '',
            });

            setEditId(selectedPoint[0]?.value);
        }
    }, [selectedPoint, sectorOptions]);

     console.log("formData", formData)
    const handleCancel = () => {
        setIsModalOpen(false);
        setFormData({ name: '' });
        setEditId('');
    };

    const handleInputChange = (field, event) => {
        const value = event?.target?.value ?? event;
        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

   
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            if (selectedPoint?.length > 0) {
                await httpHelper(`${URL_CONSTANTS.EDIT_SECTOR}/${editId}`, Method_TYPE.PUT, formData);
            } else {
                await httpHelper(`${URL_CONSTANTS.ADD_SECTOR}`, Method_TYPE.POST, formData);
            }
            getSectorValue();
            handleCancel();
        } catch (error) {
            console.error('Error saving Sector:', error);
        } finally {
            setIsLoading(false);
        }
    };

    if (!isModalOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-card rounded-lg border border-border w-full max-w-2xl max-h-[90vh] overflow-y-auto">
                {/* Header */}
                <div className="flex items-center justify-between p-6 border-b border-border">
                    <div>
                        <h2 className="font-heading font-semibold text-lg text-foreground">
                            {selectedPoint?.length > 0 ? 'Edit Sector' : 'Add Sector'}
                        </h2>
                        <p className="text-sm text-muted-foreground">
                            Configure Sector requirements and details
                        </p>
                    </div>
                    <Button variant="ghost" size="sm" onClick={handleCancel} iconName="X" />
                </div>

                {/* Form */}
                <form onSubmit={handleSubmit} className="p-6 space-y-6">
                    <div className="space-y-4">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <Input
                                label="Sector"
                                name="name"
                                value={formData.name}
                                onChange={(value) => handleInputChange('name', value)}
                                required
                            />
                        </div>
                    </div>
                    <div className="flex items-center justify-end space-x-3 pt-4 border-t border-border">
                        <Button type="button" variant="outline" onClick={handleCancel} disabled={isLoading}>
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            variant="default"
                            loading={isLoading}
                            iconName="Save"
                            iconPosition="left"
                        >
                            {selectedPoint?.length > 0 ? 'Update Sector' : 'Create Sector'}
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default SectortModal;
